import React from 'react';
import { Brain, Activity, Scale, HeartPulse, Stethoscope, FileCheck } from 'lucide-react';
import ServiceCard from '../ui/ServiceCard';
export default function ServicesSection() {
  const services = [{
    title: 'Forensic & Risk Assessments',
    description: "Fitness to plead, risk of violence, self-harm, neglect. We offer critical insights into an individual's mental state for criminal justice contexts.",
    icon: <Scale className="h-10 w-10" data-id="element-234" />,
    link: '/services/forensic-risk'
  }, {
    title: 'Neurodevelopmental Assessments (ADHD & ASD)',
    description: 'Comprehensive ADHD and Autism evaluations. We provide crucial insights into how these conditions may impact legal context or capacity.',
    icon: <Brain className="h-10 w-10" data-id="element-235" />,
    link: '/services/neurodevelopmental'
  }, {
    title: 'Mental Capacity Assessments UK',
    description: 'Capacity to litigate, testamentary, DoLS, COP3, medical treatment. We provide meticulous and objective evaluations.',
    icon: <Activity className="h-10 w-10" data-id="element-236" />,
    link: '/services/mental-capacity'
  }, {
    title: 'PTSD & Trauma Psychiatric Evaluations',
    description: 'PTSD & Complex PTSD, Istanbul Protocol compliance. Expert assessments adhering to international standards.',
    icon: <HeartPulse className="h-10 w-10" data-id="element-237" />,
    link: '/services/trauma-ptsd'
  }, {
    title: 'Specialist Psychiatric Evaluations',
    description: 'Immigration, family, criminal, employment, tribunals. Expert psychiatric opinions tailored for diverse legal settings.',
    icon: <Stethoscope className="h-10 w-10" data-id="element-238" />,
    link: '/services/specialist'
  }, {
    title: 'Clinical Negligence Cases',
    description: 'Independent psychiatric assessments for cases involving alleged failures in diagnosis, treatment, aftercare, risk management, or wider mental health care. These reports help clarify causation, impact, prognosis, and whether psychiatric injury or deterioration may be linked to substandard care.',
    icon: <FileCheck className="h-10 w-10" data-id="element-239" />,
    link: '/services/clinical-negligence'
  }];
  return <section className="py-16 bg-white" data-id="element-240">
      <div className="container mx-auto px-4" data-id="element-241">
        <h2 className="text-3xl font-serif font-bold text-primary text-center mb-12" data-id="element-242">
          Our Medico-Legal Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-243">
          {services.map((service, index) => <ServiceCard key={index} title={service.title} description={service.description} icon={service.icon} link={service.link} data-id="element-244" />)}
        </div>
      </div>
    </section>;
}